import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { class: "contributions-tables" }
const _hoisted_5 = { class: "contributions-table-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Date Claim Received"),
    /*#__PURE__*/_createElementVNode("th", null, "Date Claim Processed"),
    /*#__PURE__*/_createElementVNode("th", null, "Claim Reference #"),
    /*#__PURE__*/_createElementVNode("th", null, "Payment Reference #"),
    /*#__PURE__*/_createElementVNode("th", null, "Payment Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Admin fees"),
    /*#__PURE__*/_createElementVNode("th", null, "From CAPP ")
  ])
], -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "totals" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", { colspan: "4" }, "Totals", -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "7" }, "No Claims found for selected period.")
], -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", null, [
              _hoisted_6,
              ($setup.dataLoaded && $setup.history && $setup.history.length > 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.history, (row, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.Claims, (claim) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: claim.ClaimNumber
                          }, [
                            _createElementVNode("td", null, _toDisplayString(claim.ReceiveDate), 1),
                            _createElementVNode("td", null, _toDisplayString(claim.PostingDate), 1),
                            _createElementVNode("td", null, _toDisplayString(claim.ClaimNumber), 1),
                            _createElementVNode("td", null, _toDisplayString(claim.Reference ?? '-'), 1),
                            _createElementVNode("td", null, _toDisplayString($setup.amount(claim)), 1),
                            _createElementVNode("td", null, _toDisplayString($setup.formatCurrency(claim.Amount.AdminFee)), 1),
                            _createElementVNode("td", null, _toDisplayString($setup.formatCurrency(claim.Amount.Gross)), 1)
                          ]))
                        }), 128))
                      ], 64))
                    }), 128)),
                    _createElementVNode("tr", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("td", null, [
                        _createElementVNode("b", null, _toDisplayString($setup.formatCurrency($setup.totals.NetTotal)), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("b", null, _toDisplayString($setup.formatCurrency($setup.totals.AdminTotal)), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("b", null, _toDisplayString($setup.formatCurrency($setup.totals.GrossTotal)), 1)
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_10, _hoisted_12))
            ])
          ])
        ])
      ])
    ])
  ]))
}